export default "__VITE_ASSET__BPZ25wRb__"